import { useRef, useEffect } from 'react';
const useUpdateEffectWithKey = (effect, deps, key) => {
    const isInitialMount = useRef(true);
    useEffect(() => {
        isInitialMount.current = true;
    }, [key]);
    useEffect(() => {
        if (isInitialMount.current) {
            isInitialMount.current = false;
        }
        else {
            try {
                const cleanup = effect();
                if (cleanup && typeof cleanup === 'function') {
                    return cleanup;
                }
            }
            catch (error) {
                console.error('An error occurred in useUpdateEffectWithKey:', error);
            }
        }
    }, [...deps]);
};
export default useUpdateEffectWithKey;
